import request from './request';

export interface UploadedImage {
  id: number;
  cosKey: string;
  accessUrl: string;
  size: number;
  mimeType: string;
}

/**
 * Upload a File from the browser to COS via the standard 3-step flow:
 *   1. POST /cos/upload-url → pre-signed PUT URL
 *   2. PUT bytes to COS
 *   3. POST /cos/confirm-upload → DB Image record
 *
 * Works for both user (userAuth) and admin (adminAuth via anyAuth on confirm).
 * Admin uploads create orphan Image rows (userId=null).
 */
export async function uploadFileToCos(file: File): Promise<UploadedImage> {
  const filename = file.name || `upload-${Date.now()}.png`;
  const contentType = file.type || 'image/png';

  const presigned = await request.post<{ uploadUrl: string; cosKey: string }>(
    '/cos/upload-url',
    { filename, contentType },
  );
  const { uploadUrl, cosKey } = presigned.data;

  const putRes = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': contentType },
    body: file,
  });
  if (!putRes.ok) {
    throw new Error(`COS upload failed (${putRes.status})`);
  }

  const confirmed = await request.post<UploadedImage>('/cos/confirm-upload', {
    cosKey,
    size: file.size,
    mimeType: contentType,
  });
  return confirmed.data;
}
